module.exports = __webpack_public_path__ + "img/chat-gpt-integration-cover.a8fd1375.webp";